import React, { useState} from 'react';
import { useCart } from '../../../hooks/useCart';
import CartAmountToggle from '../../ShopComponents/CartAmountToggle';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../common/LoadingSpinner';

export default function Cart() {
  const { 
    cart, 
    loadingStates, 
    updateQuantity, 
    removeFromCart, 
    getCartTotal 
  } = useCart();
  const [couponCode, setCouponCode] = useState('');

  const handleQuantityChange = (productId, newQuantity) => {
    updateQuantity(productId, newQuantity);
  };

  const handleRemoveItem = (productId) => {
    removeFromCart(productId);
  };

  return (
    <div className="container">
      {loadingStates.syncing && (
        <div className="cs_sync_indicator">
          <LoadingSpinner size="small" />
          <span>Syncing cart...</span>
        </div>
      )}
      
      <div className="row">
        <div className="col-xl-8">
          <div className="table-responsive">
            <table className="cs_cart_table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Subtotal</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {cart.map((item) => (
                  <tr key={item.id} className={loadingStates.updatingQuantity ? 'updating' : ''}>
                    <td>
                      <div className="cs_cart_table_media">
                        <img src={item.productThumb} alt={item.title} />
                        <h3>{item.title}</h3>
                      </div>
                    </td>
                    <td>${item.price.toFixed(2)}</td>
                    <td>
                      <CartAmountToggle 
                        quantity={item.quantity} 
                        setQuantity={(newQty) => handleQuantityChange(item.id, newQty)}
                        stock={item.stock}
                        price={item.price}
                        disabled={loadingStates.updatingQuantity}
                      />
                    </td>
                    <td>${(item.price * item.quantity).toFixed(2)}</td>
                    <td>
                      <button 
                        className="cs_cart-table-close"
                        onClick={() => handleRemoveItem(item.id)}
                        disabled={loadingStates.removingItem}
                      >
                        {loadingStates.removingItem ? (
                          <LoadingSpinner size="small" />
                        ) : (
                          <i className="fa-solid fa-xmark" />
                        )}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="cs_cart-offer">
            <div>
              <div className="cs_coupon-code-form">
                <input 
                  type="text" 
                  placeholder="Coupon Code"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />
                <button className="cs_product_btn cs_color1 cs_semi_bold">
                  Apply Coupon
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="cs_shop-side-spacing">
            <div className="cs_shop-card">
              <h2>Cart Totals</h2>
              <table className="cs_medium">
                <tbody>
                  <tr>
                    <td className="cs_semi_bold">Subtotal</td>
                    <td className="text-end">${getCartTotal().toFixed(2)}</td>
                  </tr>
                  <tr className="cs_semi_bold">
                    <td>Total</td>
                    <td className="text-end">${getCartTotal().toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
              <div className="cs_height_30 cs_height_lg_30" />
              <Link
                className="cs_product_btn cs_semi_bold w-100"
                to="/shop/checkout"
              >
                Proceed To Checkout
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
